/**
 * Hook para feedback tátil (vibração)
 * Simula o haptic feedback do iOS
 */
export function useHaptic() {
  const isSupported = 'vibrate' in navigator;

  /**
   * Feedback leve - usado para taps em botões, seleções
   */
  const light = () => {
    if (!isSupported) return;
    
    // Padrão iOS-style light impact
    if (navigator.vibrate) {
      navigator.vibrate(10);
    }
  };

  /**
   * Feedback médio - usado para ações importantes
   */
  const medium = () => {
    if (!isSupported) return;
    
    if (navigator.vibrate) {
      navigator.vibrate(20);
    }
  };

  /**
   * Feedback pesado - usado para sucesso, confirmações
   */
  const heavy = () => {
    if (!isSupported) return;
    
    if (navigator.vibrate) {
      navigator.vibrate([30, 50, 30]);
    }
  };

  /**
   * Padrão de sucesso
   */
  const success = () => {
    if (!isSupported) return;
    
    if (navigator.vibrate) {
      navigator.vibrate([10, 50, 20]);
    }
  };

  /**
   * Padrão de erro
   */
  const error = () => {
    if (!isSupported) return;
    
    if (navigator.vibrate) {
      navigator.vibrate([50, 100, 50]);
    }
  };

  return {
    isSupported,
    light,
    medium,
    heavy,
    success,
    error,
  };
}

export default useHaptic;
